<div class="visitor-identification">
  <div class="visitor-identification__content">
    <app-header />

    <div class="visitor-identification__main">
      <section class="visitor-identification__hero" aria-labelledby="visitor-identification-title">
        <h1 id="visitor-identification-title" class="visitor-identification__title">
          Merci de vous identifier
        </h1>
      </section>

      <section class="visitor-identification__panel" aria-label="Formulaire d'identification">
        <!--
          Une seule région live pour les deux erreurs : deux `role="alert"`
          distincts provoqueraient deux annonces successives. Les bulles
          visuelles sont donc masquées aux lecteurs d'écran, qui lisent ce
          résumé unique.
        -->
        <div class="sr-only" role="alert">
          @if (showNameError()) {
            <p>Veuillez saisir votre nom et prénom</p>
          }
          @if (showCompanyError()) {
            <p>Veuillez indiquer votre société ou cocher la case</p>
          }
        </div>

        @if (showNameError()) {
          <div aria-hidden="true">
            <app-field-error-tooltip
              text="Veuillez saisir votre&#10;nom et prénom"
              [offsetTop]="35"
            />
          </div>
        }

        <!--
          Ancrée au panneau comme la bulle du nom, et non au bloc société :
          ancrée au bloc, elle héritait des 40px de padding gauche du panneau et
          venait chevaucher le champ. offsetTop = 35 + 72 (hauteur de la ligne
          nom/prénom) + 20 (gouttière) = 127.
        -->
        @if (showCompanyError()) {
          <div aria-hidden="true">
            <app-field-error-tooltip
              text="Veuillez indiquer votre société&#10;ou cocher la case"
              [offsetTop]="127"
            />
          </div>
        }

        <div class="visitor-identification__form">
          <div class="visitor-identification__name-row">
            <div
              class="visitor-identification__field"
              [class.visitor-identification__field--error]="hasFieldError('lastName')"
              [class.visitor-identification__field--focused]="focusedField() === 'lastName'"
              role="textbox"
              tabindex="0"
              aria-label="Nom"
              (click)="focusField('lastName')"
            >
              <span
                class="visitor-identification__field-label"
                [class.visitor-identification__field-label--hidden]="displayValue('lastName').length > 0"
              >Nom</span>
              <div class="visitor-identification__input">
                <span class="visitor-identification__value">{{ displayValue('lastName') }}</span>
                @if (focusedField() === 'lastName') {
                  <span class="visitor-identification__caret" aria-hidden="true"></span>
                }
              </div>
            </div>

            <div
              class="visitor-identification__field"
              [class.visitor-identification__field--error]="hasFieldError('firstName')"
              [class.visitor-identification__field--focused]="focusedField() === 'firstName'"
              role="textbox"
              tabindex="0"
              aria-label="Prénom"
              (click)="focusField('firstName')"
            >
              <span
                class="visitor-identification__field-label"
                [class.visitor-identification__field-label--hidden]="displayValue('firstName').length > 0"
              >Prénom</span>
              <div class="visitor-identification__input">
                <span class="visitor-identification__value">{{ displayValue('firstName') }}</span>
                @if (focusedField() === 'firstName') {
                  <span class="visitor-identification__caret" aria-hidden="true"></span>
                }
              </div>
            </div>
          </div>

          <div class="visitor-identification__company-block">
            <div
              class="visitor-identification__field"
              [class.visitor-identification__field--error]="hasFieldError('company')"
              [class.visitor-identification__field--focused]="focusedField() === 'company'"
              [class.visitor-identification__field--muted]="noCompany()"
              role="textbox"
              tabindex="0"
              aria-label="Nom de société"
              [attr.aria-disabled]="noCompany() ? 'true' : null"
              (click)="focusCompany()"
            >
              <span
                class="visitor-identification__field-label"
                [class.visitor-identification__field-label--hidden]="displayValue('company').length > 0"
              >Nom de société</span>
              <div class="visitor-identification__input">
                <span class="visitor-identification__value">{{ displayValue('company') }}</span>
                @if (focusedField() === 'company') {
                  <span class="visitor-identification__caret" aria-hidden="true"></span>
                }
              </div>
            </div>

            <app-touch-checkbox
              label="Je ne représente pas de société"
              [checked]="noCompany()"
              (toggled)="toggleNoCompany()"
            />
          </div>

          <app-virtual-keyboard
            (keyPress)="onKeyPress($event)"
            (backspace)="onBackspace()"
            (space)="onSpace()"
            (validate)="onValidate()"
          />
        </div>
      </section>
    </div>

    <app-footer>
      <app-footer-nav [showScrollButton]="false" backRoute="/" />
    </app-footer>
  </div>
</div>
